import { MessageCircle, Tag } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { waLink } from "@/config";

const PRODUCTS = [
  {
    id: "camisa-linho",
    name: "Camisa de Linho Premium",
    price: "129,90",
    img: "https://images.unsplash.com/photo-1596755094514-f87e34085b2c?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: "vestido-floral",
    name: "Vestido Floral de Verão",
    price: "189,90",
    img: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: "jaqueta-jeans",
    name: "Jaqueta Jeans Clássica",
    price: "249,90",
    img: "https://images.unsplash.com/photo-1551028719-00167b16eac5?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: "camiseta-basica",
    name: "Camiseta Básica de Algodão",
    price: "59,90",
    img: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: "jeans-premium",
    name: "Jeans Premium",
    price: "199,90",
    img: "https://images.unsplash.com/photo-1473966968600-fa801b869a1a?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: "mochila-viagem",
    name: "Mochila de Viagem",
    price: "219,90",
    img: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?q=80&w=800&auto=format&fit=crop",
  },
];

export const Storefront = () => (
  <section id="loja" data-testid="storefront-section" className="relative bg-navy grain py-20 lg:py-32 overflow-hidden">
    <div className="absolute -bottom-40 right-0 w-[36rem] h-[36rem] rounded-full bg-gold/10 blur-[130px] pointer-events-none" />

    <div className="relative z-10 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold mb-5">
          Vitrine da Loja
        </p>
        <h2
          data-testid="storefront-title"
          className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight leading-snug text-ivory max-w-2xl"
        >
          Peças selecionadas para você{" "}
          <em className="italic text-gold">viajar com estilo.</em>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-ivory/60 leading-relaxed max-w-xl">
          Escolha sua peça e peça direto pelo WhatsApp — retirada na loja ou
          entrega combinada com nossa equipe.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {PRODUCTS.map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.08}>
            <article
              data-testid={`product-card-${p.id}`}
              className="group bg-ivory rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-1.5 transition-all duration-500"
            >
              <div className="relative overflow-hidden aspect-[4/5]">
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-navy/85 backdrop-blur-sm text-gold font-mono text-[10px] uppercase tracking-[0.15em] px-3 py-1.5 rounded-full">
                  <Tag className="w-3 h-3" />
                  Novidade
                </span>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="font-serif text-lg sm:text-xl font-semibold text-navy leading-snug">
                  {p.name}
                </h3>
                <p
                  data-testid={`product-price-${p.id}`}
                  className="mt-2 font-mono text-sm sm:text-base font-semibold text-gold-bronze"
                >
                  R$ {p.price}
                </p>
                <a
                  href={waLink(
                    `Olá, A.S.F Viagens! Vi a peça *${p.name}* (R$ ${p.price}) na vitrine do site e gostaria de fazer um pedido.`
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`product-order-${p.id}`}
                  className="mt-4 inline-flex w-full items-center justify-center gap-2 bg-navy text-ivory text-sm font-semibold px-5 py-3 rounded-full hover:bg-gold hover:text-navy transition-all duration-300"
                >
                  <MessageCircle className="w-4 h-4" />
                  Pedir pelo WhatsApp
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
